export default __webpack_public_path__ + "static/malmo-9298d5d5e6ed835983f9769087b10ce9.jpg";